import { render, staticRenderFns } from "./AboutContentListItemConnector.vue?vue&type=template&id=56ae5233&scoped=true&"
import script from "./AboutContentListItemConnector.vue?vue&type=script&lang=js&"
export * from "./AboutContentListItemConnector.vue?vue&type=script&lang=js&"
import style0 from "./AboutContentListItemConnector.vue?vue&type=style&index=0&id=56ae5233&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae5233",
  null
  
)

export default component.exports